import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { NsKey } from 'enums/NsKey';

// Cache-buster des JSON de locales : les fichiers /locales/* gardent une URL
// stable, donc navigateurs et proxys les servent depuis leur cache tant que
// `v` ne change pas — un `v` figé laissait les nouvelles clés brutes en prod
// pendant des jours après une livraison. REACT_APP_BUILD_ID est injecté par la
// pipeline (Build.BuildId, inliné par CRA au build) : chaque déploiement
// invalide le cache, et entre deux déploiements le cache reste pleinement actif.
const version = process.env.REACT_APP_BUILD_ID ?? '2.0.0';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    debug: false,
    defaultNS: 'common',
    ns: [
      NsKey.Common,
      NsKey.ActorForm,
      NsKey.Mandate,
      NsKey.Contractualization,
      NsKey.Pricing,
      NsKey.Profiling,
      NsKey.Borrower,
      NsKey.RealEstate,
      NsKey.Risk,
      NsKey.Quote,
      NsKey.Contract,
      NsKey.Document,
      NsKey.Product,
      NsKey.Note,
      NsKey.MncapMedicalValidation,
      NsKey.IdentityUpload,
      NsKey.PersonneMorale,
      NsKey.Validation
    ],
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${version}`,
    }
  });

export default i18n;
